import type { Metric } from '@/payload/payload.types';

export const metricStatusText = <
  T extends Pick<Metric, 'trendArrowBackground' | 'trendArrowDirection'>,
>(
  data: T,
) => {
  if (data.trendArrowDirection === 'no_data') {
    return 'Ebapiisavalt andmeid';
  }

  if (data.trendArrowDirection === 'same') {
    return 'Mõõdik on paigalseisus';
  }

  if (data.trendArrowDirection === 'down') {
    if (data.trendArrowBackground === 'red') {
      return 'Mõõdik ei ole sihil';
    }
    return 'Mõõdik on sihil';
  }

  if (data.trendArrowDirection === 'up') {
    if (data.trendArrowBackground === 'red') {
      return 'Mõõdik ei ole sihil';
    }
    return 'Mõõdik on sihil';
  }
};
